<template>
	<div class="page_box">
		<div class="msg" v-loading="isLoading" v-if="isLoading"></div>
		<div class="header_box">
			<div class="header_item">
				<img src="../assets/img/icon_zrzs.png" alt="">
				<div>{{headerData[0]}}</div>
				<div>证书昨日数</div>
			</div>
			<div class="header_item">
				<img src="../assets/img/icon_zrpz.png" alt="">
				<div>{{headerData[1]}}</div>
				<div>牌照昨日数</div>
			</div>
			<div class="header_item">
				<img src="../assets/img/icon_zszs.png" alt="">
				<div>{{headerData[2]}}</div>
				<div>证书总数</div>
			</div>
			<div class="header_item">
				<img src="../assets/img/icon_pzzs.png" alt="">
				<div>{{headerData[3]}}</div>
				<div>牌照总数</div>
			</div>
		</div>
		<div class="echarts_box">
			<div class="filter_box">
				<span>时间</span>
				<el-date-picker :picker-options="pickerOptions" type="date" value-format="yyyy-MM-dd" v-model="queryInfo.startTime" @change="init"></el-date-picker>
				<!-- <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="queryInfo.endTime" @change="init"></el-date-picker> -->
			</div>
			<div class="echart">
				<div class="title"><img src="../assets/img/icon_bd_zs.png" alt="">证书30天数据</div>
				<div style="width: 100%;" id="myChart1"></div>
			</div>
			<div class="echart">
				<div class="title"><img src="../assets/img/icon_bd_pz.png" alt="">牌照30天数据</div>
				<div style="width: 100%;" id="myChart2"></div>
			</div>
		</div>
		<div class="table_box">
			<span class="title">分支机构列表</span>
			<el-tabs v-model="activeName">
				<el-tab-pane label="证书列表" name="first">
					<el-table :data="tableData1" height="480" border style="width: 100%">
					  <el-table-column
					    prop="name"
					    label="分支机构名称"
					    width="180"
					    align:center
					  >
					  </el-table-column>
					  <el-table-column
					    prop="dayNum"
					    label="昨日新增数量"
					    width="180"
					    text-align:center
					    sortable
					  >
					  </el-table-column>
					  <el-table-column
					    prop="monthNum"
					    label="30天新增数量"
					    text-align:center
					    sortable
					  >
					  </el-table-column>
					  <el-table-column
					    prop="allNum"
					    label="总量"
					    text-align:center
					    sortable
					  >
					  </el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="牌照列表" name="second">
					<el-table :data="tableData2" height="480" border style="width: 100%">
					  <el-table-column
					    prop="name"
					    label="分支机构名称"
					    width="180"
					    align:center
					  >
					  </el-table-column>
					  <el-table-column
					    prop="dayNum"
					    label="昨日新增数量"
					    width="180"
					    text-align:center
					    sortable
					  >
					  </el-table-column>
					  <el-table-column
					    prop="monthNum"
					    label="30天新增数量"
					    text-align:center
					    sortable
					  >
					  </el-table-column>
					  <el-table-column
					    prop="allNum"
					    label="总量"
					    text-align:center
					    sortable
					  >
					  </el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	import {getEchartData} from '../api/index.js';
	export default{
		data(){
			return{
				queryInfo: {
					startTime: '',
					endTime: ''
				},
				activeName: 'first',
				headerData: [],
				tableData1: [],
				tableData2: [],
				isLoading: false,
				pickerOptions: {}
			}
		},
		created() {
			//获取当前时间
			let myDate = new Date();
			let arr = myDate.toLocaleDateString();
			this.queryInfo.endTime = arr;
			//获取三十天前日期
			let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30);//最后一个数字30可改，30天的意思
			let lastY = lw.getFullYear();
			let lastM = lw.getMonth()+1;
			let lastD = lw.getDate();
			let startdate=lastY+"-"+(lastM<10 ? "0" + lastM : lastM)+"-"+(lastD<10 ? "0"+ lastD : lastD);//三十天之前日期
			this.queryInfo.startTime = startdate;
			this.pickerOptions.disabledDate = (time) => {
				return time.getTime() > new Date(startdate).getTime();
			},
			this.init();
		},
		methods:{
			init(){
				this.isLoading = true;
				getEchartData(this.queryInfo).then(res => {
					this.isLoading = false;
					if(res.code == 0){
						this.headerData = res.data.headerData;
						// this.certificateData   证书数据
						let chartDom1 = document.getElementById('myChart1');
						let chartDom2 = document.getElementById('myChart2');
						let myChart1 = echarts.init(chartDom1);
						let myChart2 = echarts.init(chartDom2);
						let option1 = {
							color: ['#FDC520'],
							legend:{
								data: ['证书数']
							},
							tooltip: {
								trigger: 'axis'
							},
							xAxis: {
							    type: 'category',
							    data: res.data.certificateData.map(item => {
									return (item.xdata.substring(5));
								})
							},
							yAxis: {
							    type: 'value'
							},
							series: [{
							    data: res.data.certificateData.map(item => {
							    	return item.ydata;
							    }),
								name: '证书数',
							    type: 'line'
							}]
						};
						let option2 = {
							legend:{
								data: ['牌照数']
							},
							tooltip: {
								trigger: 'axis'
							},
							xAxis: {
							    type: 'category',
							    data: res.data.equipmentData.map(item => {
									return (item.xdata.substring(5));
								})
							},
							yAxis: {
							    type: 'value'
							},
							series: [{
							    data: res.data.equipmentData.map(item => {
							    	return item.ydata;
							    }),
								name: '牌照数',
							    type: 'line'
							}]
						}
						myChart1.setOption(option1);
						myChart2.setOption(option2);
						res.data.endCertificateData.forEach(item => {
							item.allNum = Number(item.allNum);
							item.dayNum = Number(item.dayNum);
							item.monthNum = Number(item.monthNum);
						})
						res.data.endEquipmentData.forEach(item => {
							item.allNum = Number(item.allNum);
							item.dayNum = Number(item.dayNum);
							item.monthNum = Number(item.monthNum);
						})
						this.tableData1 = res.data.endCertificateData;   //分支机构证书
						this.tableData2 = res.data.endEquipmentData;     //分支机构牌照
					}else if(res.code == 1){
						this.$message({
							message: res.message,
							type: 'warning'
						});
					}else{
						this.$message({
							message: '报错啦!',
							type: 'warning'
						})
					}
				})
			},
		}
	}
</script>

<style scoped="scoped">
	.msg{
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		z-index: 100;
	}
	.page_box{
		padding-top: 16px;
	}
	.header_box .header_item{
		float: left;
		background-color: #ffffff;
		width: 23.74%;
		height: 184px;
		margin-left: 1.26%;
		margin-bottom: 16px;
	}
	.header_item img{
		padding-top: 20px;
		padding-left: 20px;
		display: block;
	}
	.header_item div{
		padding-left: 20px;
		padding-top: 20px;
		font-size: 20px;
		font-weight: 600;
	}
	.header_item div:last-of-type{
		font-size: 14px;
		padding-top: 14px;
		font-weight: 400;
	}
	.echarts_box{
		clear: both;
		margin-left: 16px;
		background-color: #ffffff;
		width: calc(100% - 16px);
		height: 900px;
		margin-bottom: 20px;
	}
	.echarts_box .filter_box{
		padding-left: 20px;
		padding-top: 20px;
	}
	.filter_box span{
		display: block;
		margin-bottom: 6px;
	}
	.echart{
		margin-left: 20px;
	}
	.echart .title{
		margin-top: 10px;
		height: 40px;
		font-size: 18px;
		line-height: 40px;
		font-weight: 600;
	}
	.echart .title img{
		position: relative;
		top: 3px;
	}
	.echart div:last-of-type{
		width: 80%;
		height: 350px;
	}
	.table_box{
		clear: both;
		padding-top: 20px;
		width: calc(100% - 16px);
		margin-left: 16px;
		height: 600px;
		background-color: #ffffff;
	}
	.table_box .title{
		padding-left: 20px;
		font-size: 18px;
		font-weight: 600;
	}
	.table_box .el-tabs{
		margin-left: 16px;
		margin-top: 10px;
		margin-right: 16px;
	}
</style>
